import AutocompleteAsyncMultiFormik from "../../../../../common/components/form/AutocompleteAsyncMultiFormik";
import { Addition, getAdditions } from "../../../../../common/services/plans.api";


interface AvailableAdditionsFieldFormikProps {
  initialValues?: Array<{ label: string; value: number; key: string }>;
}

export function AvailableAdditionsFieldFormik({ initialValues }: AvailableAdditionsFieldFormikProps) {
  const loadOptions = async () => {
    const result = await getAdditions() as { ok: boolean, data: Addition[] };
    if (!result.ok) {
      return [];
    }

    const options = Object.keys(result.data).map(key => ({
      label: result.data[key].label,
      value: result.data[key].value,
      key: key,
    }));

    return options;
  };

  return (
    <AutocompleteAsyncMultiFormik
      label="Serviços adicionais:"
      name="additions"
      valueProperty="label"
      loadOptions={loadOptions}
      isMulti={true}
      initialValue={initialValues}
    />
  );
}
